import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Outlet} from '@github-ui/react-router'
import {PageLayout} from '@primer/react'

import {SettingsErrorFallback} from './settings-error-fallback'
import {ReorderableSettingsSideNav} from './settings-side-nav'
import styles from './settings-view.module.css'

export const SettingsView = () => {
  return (
    <PageLayout containerWidth="full" className={styles.PageLayout}>
      <PageLayout.Pane position="start" className={styles.Pane}>
        <ReorderableSettingsSideNav />
      </PageLayout.Pane>
      <PageLayout.Content width="large" className={styles.Content}>
        <ErrorBoundary fallback={<SettingsErrorFallback />}>
          <Outlet />
        </ErrorBoundary>
      </PageLayout.Content>
    </PageLayout>
  )
}
